(function () {
  var rootSelector = '[data-product-page-layout="gallery-buy-rail"]';
  var accordionSelector = '.product-details [data-sp-personalization-accordion]';
  var hiddenClass = 'sp-personalization-rail--hidden';
  var activeClass = 'sp-personalization-rail--active';
  var pendingClass = 'sp-personalization-rail--pending';

  function variantNeedsPersonalization(entry) {
    if (!entry) return null;

    if (entry.requires_personalization === true) return true;
    if (entry.requires_personalization === false) return false;

    return null;
  }

  function readPersonalizationMap(root) {
    var script = root.querySelector('[data-sp-personalization-map]');
    if (!script) return {};

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (_error) {
      return {};
    }
  }

  function currentVariantId(root) {
    var input = root.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return input && input.value;
  }

  function hasRenderedPersonalizationFields(accordion) {
    var content = accordion.querySelector('.details-content');
    if (!content) return false;

    return Boolean(
      content.querySelector(
        [
          'input[required]:not([type="hidden"]):not([disabled])',
          'textarea[required]:not([disabled])',
          'select[required]:not([disabled])',
          '[contenteditable="true"]',
          '[data-required="true"]',
          '[aria-required="true"]',
          '[data-field-type*="engraving" i]',
          '[data-field-type*="upload" i]',
          '[data-field-type*="personal" i]',
          '[name*="engraving" i]:not([type="hidden"]):not([disabled])',
          '[name*="upload" i]:not([type="hidden"]):not([disabled])',
          '[name*="personal" i]:not([type="hidden"]):not([disabled])',
          '.so-engraving',
          '.so-upload',
          '.so-fontable[data-required="true"]',
          '.so-hyper-field[data-required="true"]'
        ].join(',')
      )
    );
  }

  function setState(accordion, state) {
    accordion.classList.toggle(hiddenClass, state === 'hidden');
    accordion.classList.toggle(activeClass, state === 'active');
    accordion.classList.toggle(pendingClass, state === 'pending');
    accordion.hidden = state === 'hidden';
    accordion.dataset.spPersonalizationState = state;

    if (state === 'active') {
      var details = accordion.querySelector('details');
      if (details) {
        details.open = true;
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    }
  }

  function openByDefault(accordion, variantId) {
    var details = accordion.querySelector('details');
    if (!details) return;

    var autoOpenKey = variantId || 'fallback';
    if (accordion.dataset.spAutoOpenedVariant === autoOpenKey) return;

    details.open = true;
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
    accordion.dataset.spAutoOpenedVariant = autoOpenKey;
  }

  function evaluate(root, state) {
    var accordion = root.querySelector(accordionSelector);
    if (!accordion) return;

    var map = state.map || {};
    var variantId = currentVariantId(root);
    var entry = variantId ? map[variantId] : null;
    var mappedNeed = variantNeedsPersonalization(entry);

    if (mappedNeed === true) {
      setState(accordion, 'active');
      openByDefault(accordion, variantId);
      return;
    }

    if (mappedNeed === false) {
      setState(accordion, 'hidden');
      return;
    }

    if (hasRenderedPersonalizationFields(accordion)) {
      setState(accordion, 'active');
      openByDefault(accordion, variantId);
      return;
    }

    setState(accordion, 'pending');
  }

  function initRoot(root) {
    if (root.dataset.spPersonalizationReady === 'true') return;
    root.dataset.spPersonalizationReady = 'true';

    var accordion = root.querySelector(accordionSelector);
    if (!accordion) return;

    var state = { map: readPersonalizationMap(root) };
    var content = accordion.querySelector('.details-content') || accordion;

    evaluate(root, state);

    var observer = new MutationObserver(function () {
      evaluate(root, state);
    });
    observer.observe(content, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'data-required', 'disabled', 'hidden', 'name', 'required', 'style', 'type']
    });

    root.addEventListener('change', function () {
      window.setTimeout(function () {
        evaluate(root, state);
      }, 80);
      window.setTimeout(function () {
        evaluate(root, state);
      }, 350);
    });

    window.setTimeout(function () {
      evaluate(root, state);
    }, 1200);
    window.setTimeout(function () {
      if (accordion.dataset.spPersonalizationState === 'pending') {
        if (hasRenderedPersonalizationFields(accordion)) {
          setState(accordion, 'active');
          openByDefault(accordion, currentVariantId(root));
          return;
        }

        setState(accordion, 'hidden');
      }
    }, 8000);
  }

  function init() {
    document.querySelectorAll(rootSelector).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
